export const PartySVGMultiColour = ({ className }: { className?: string }) => {
    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M10.8711 10.8228L16.5055 10.8228"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6885 8L13.6885 13.6462"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.9994 8L30.5908 13.6462"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.3115 10.8228L55.9459 10.8228"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M53.1289 8L53.1289 13.6462"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M41.8602 22.1152L39.043 24.9383"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.3115 33.4076L55.9459 31.9961"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.3115 50.3467L55.9459 50.3467"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M53.1289 47.5229L53.1289 53.1691"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.0478 43.3393L20.6853 24.9385L8.31784 51.9836C8.0734 52.5087 7.99611 53.0964 8.09648 53.6671C8.19684 54.2377 8.46999 54.7635 8.87885 55.1733C9.28771 55.583 9.81248 55.8567 10.3819 55.9573C10.9514 56.0578 11.5379 55.9804 12.0619 55.7354L39.0478 43.3393Z"
                stroke="#08172B"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
